import { get } from 'lodash';

export class UrlAnalyticModel {
  utm_source: string;
  utm_medium: string;
  utm_campaign: string;
  ecid: string;
  pid: string;
  arc: string;
  pm: string
  qrCd: string;
  form_type: string;

  constructor(initial: any) {
    this.utm_source = get(initial, 'utm_source', "");
    this.utm_medium = get(initial, 'utm_medium', "");
    this.utm_campaign = get(initial, 'utm_campaign', "");
    this.ecid = get(initial, 'ecid', "");
    this.pid = get(initial, 'pid', "");
    this.arc = get(initial, 'arc', "");
    this.pm = get(initial, 'pm', "");
    this.qrCd = get(initial, 'qrCd', "");
    this.form_type = get(initial, 'form_type', "");
  }
}

export class UrlAnalyticTrackingModel{
  json: UrlAnalyticModel;

  constructor(initial : UrlAnalyticModel){
    this.json = {...initial};
  }

  get trackingCodeJson():Object {
    if(this.json.ecid || this.json.pid || this.json.arc || this.json.qrCd || this.json.pm || this.json.form_type)
    {
      return JSON.stringify({
        "ecid":this.json.ecid,
        "pid":this.json.pid,
        "pm":this.json.pm?.replace(/ /g, "+"),
        "arc":this.json.arc?.replaceAll(/\s/g,""),
        "qrCd":this.json.qrCd?.replaceAll(/\s/g,""),
        "formType":this.json.form_type,
      });
    }
    return "";
  }

}